var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"data-timestamp":_vm.timestamp * 1000,"title":_vm.title}},[_vm._v(_vm._s(_vm.formatted))])
}
var staticRenderFns = []

export { render, staticRenderFns }